import { FC } from 'react';

import { IButtonProps } from './interfaces/IButtonProps';
import { Button, useTheme } from '@material-ui/core';
import getSizeButtons from './GetSizeButtons';
import { useMediaQuery } from '@mui/material';

const UnfilledButton: FC<IButtonProps> = ({ text, onClick, size = 'md', ...props }) => {
    const theme = useTheme();
    const matchSm = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Button
            {...props}
            variant="contained"
            onClick={onClick}
            sx={{
                minWidth: matchSm ? undefined : getSizeButtons(size),
                backgroundColor: theme.palette.background?.paper,
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.primary?.main,
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 700,
                border: `1px solid ${theme.palette.primary?.main}`,
                padding: '8px',
                boxShadow: 'none',
                '&:hover': {
                    '@media (hover: none)': {
                        backgroundColor: theme.palette.background?.paper,
                        color: theme.palette.primary?.main,
                        boxShadow: 'none'
                    },
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.background?.paper
                },
                '&:disabled': {
                    borderColor: 'currentColor'
                }
            }}
        >
            {text}
        </Button>
    );
};

export default UnfilledButton;
